import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogTemplateComponent } from '@optsolservices/ngx-confirm-dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-pos-rcs-account-payment-with-money-equipment',
  templateUrl: './pos-rcs-account-payment-with-money-equipment.component.html',
  styleUrls: ['./pos-rcs-account-payment-with-money-equipment.component.scss']
})
export class PosRcsAccountPaymentWithMoneyEquipmentComponent implements OnInit {
  storeId: number;
  containerId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;
  busy: boolean = false;
  rcsForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PosRcsAccountPaymentWithMoneyEquipmentComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public fb: FormBuilder
  ) {
    this.rcsForm = fb.group({
      cardNumber: [null, Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19),Validators.pattern('[0-9]+')])],
    })
  }

  ngOnInit() {
  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  save() {
    if (this.formValue.amountTendered <= 0) {
      const dialogRef = this.dialog.open(ConfirmDialogTemplateComponent, {
        width: '450px',
        data: {
          title: 'Negative Payment Amount',
          text: `The amount to put on the RCS account cannot be negative or zero.`,
          confirmButtonText: 'OK',
          cancelButtonText: 'No',
          showConfirmButton: true,
          showCancelButton: false
        }
      });

    } else {
      this.busy = true;
      const payload = {
        storeId: this.storeId,
        containerId: this.containerId,
        equipmentTypeCode: this.equipmentTypeCode,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue,
        rcsCard: this.rcsForm.value.cardNumber
      };

      this.baseService.executeCommand<any>('portal_pos_payment_capture_rcs_account_transaction', payload)
        .subscribe(
          response => {
            this.busy = false;
            if (response.responseCode === 0) {
              this.dialogRef.close(true);
            }
          },
          error => {
            this.busy = false;
          }
        )
    }
  }
}
